import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Routing, RoutingCreate, RoutingFilter } from '../data/routing';

export function createRoutingService(client: AxiosInstance) {
  return createCrudService<Routing, RoutingCreate, RoutingFilter>(
    client,
    '/manufacturing/Routing',
    'id',
  );
}

export type RoutingService = CrudService<Routing, RoutingCreate, RoutingFilter>;
